import { memo, useEffect, useRef, useState } from "react";
import { useSelector, shallowEqual } from "react-redux";
import { Card, Col } from "react-bootstrap";

import styles from "./CardBlock.module.scss";

const clamp = (v, min, max) => Math.min(max, Math.max(min, v));

const CardBlock = ({
  number = 0,
  time = 2000,
  title,
  title_en,
  desc,
  desc_en,
  image,
}) => {
  const language = useSelector(
    (s) => s.LangSlice?.language ?? "ru",
    shallowEqual
  );

  const [currVal, setCurrVal] = useState(0);
  const startRef = useRef(null);
  const rafRef = useRef(null);

  useEffect(() => {
    setCurrVal(0);
    startRef.current = null;

    const duration = Math.max(0, (Number(time) || 0) * 1.5);
    const target = Math.max(0, Number(number) || 0);

    const tick = (t) => {
      if (startRef.current == null) startRef.current = t;
      const elapsed = t - startRef.current;
      if (duration === 0) {
        setCurrVal(target);
        return;
      }
      const progress = clamp(elapsed / duration, 0, 1);
      const next = Math.round(progress * target);
      setCurrVal(next);
      if (progress < 1) rafRef.current = requestAnimationFrame(tick);
    };

    rafRef.current = requestAnimationFrame(tick);
    return () => {
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
      rafRef.current = null;
    };
  }, [number, time]);

  const titleHtml = language === "en" ? title_en : title;
  const descHtml = language === "en" ? desc_en : desc;

  return (
    <Col>
      <Card className={styles.card}>
        <Card.Body className={styles.cardBody}>
          <div className={styles.countBlock}>
            <p>{currVal}</p>
          </div>
          {titleHtml && (
            <p
              className={styles.titleBlock}
              dangerouslySetInnerHTML={{ __html: titleHtml }}
            />
          )}
          {descHtml && (
            <p
              className={styles.infoBlock}
              dangerouslySetInnerHTML={{ __html: descHtml }}
            />
          )}
        </Card.Body>
        {image && (
          <Card.Img
            src={image}
            className={styles.image}
            loading="lazy"
            alt=""
          />
        )}
      </Card>
    </Col>
  );
};

export default memo(CardBlock);
